import { jsx as _jsx } from "react/jsx-runtime";
import styles from './HighlightedNumber.module.css';
const HighlightedNumber = ({ value, color = 'transparent', className = '', onClick, }) => {
    return (_jsx("span", Object.assign({ onClick: onClick, className: `${className ? className : styles.root}`, style: { background: `${color}` } }, { children: _jsx("span", { children: value }, void 0) }), void 0));
};
export default HighlightedNumber;
